export default __webpack_public_path__ + "static/media/SquareGreen.7c74baaa.svg";